//引入封装好的axios
import axios from '@/request/axios';
const filepath =  process.env.VUE_APP_BASE_API;
export const noticelist = p => axios.get('/system/notice/list', p); //新闻管理


export const supplier_enter = p => axios.post('/system/supplier_enter', p); //注册
// export const noticelist = p => axios.get('/system/notice/list', p); //新闻管理
export const getCodes = p => axios.get('/sms/getCode/'+p); //获取验证码
export const check = p => axios.get('/sms/check',p); //验证码校验

export const updatePwdCode = p => axios.get('/sms/updatePwdCode/'+p); //忘记密码获取验证码
export const updatePwd = p => axios.post('/sms/updatePwd', p); //忘记密码提交




export const consu = p => axios.post('/system/consu', p); //立即咨询
export const getfileupload =  'https://192.168.1.50:28000/system/res_file/fileupload'; 
// export const login =  'http://192.168.1.50:28000/login'; 
export const login = p => axios.post(`${filepath}/login`, p); //立即咨询

export const getfilepath = `${filepath}/profile/`;//生产环境

export const getFilesName = p => axios.get('/system/supplier_protocol/getFilesName', p); //协议列表
export const authFileByUserId = p => axios.post('/system/supplier_protocol/authFileByUserId', p); //同意协议
export const sys_notice_zx = p => axios.post('/system/sys_notice_zx', p); //咨询新增

